/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Link,
  Paper,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import parse from 'html-react-parser';
import moment from 'moment';
import webinaireImg from '../img/webinaire_3.jpg';
import webinaireServices from '../../redux/services/webinaireServices';
import { Loading } from '../../helpers/utils';
import { useWebinaireListStyles, formatDurationMinutes } from './webinaireStyles';

const bgStyle = {
  backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.94)), url(${webinaireImg})`,
};

const RegisteredWebinaire = ({ userData, setErrorSnackBar, setSuccessSnackBar }) => {
  const classes = useWebinaireListStyles();
  const [webinaires, setWebinaires] = useState([]);
  const [loading, setLoading] = useState(true);

  const getWebinairesData = async () => {
    const webinaireRes = await webinaireServices.getWebinaires();
    if (webinaireRes && webinaireRes.length > 0) {
      const newWebinaires = webinaireRes.filter((webinaire) => webinaire.registered.includes(userData._id));
      await Promise.all(newWebinaires.map(async (webinaire) => {
        const meetingData = await webinaireServices.getZoomLink(webinaire.meetingId);
        if (meetingData && meetingData.join_url) {
          webinaire.zoomLink = meetingData.join_url;
        }
      }));
      setWebinaires(newWebinaires);
      setLoading(false);
    } else {
      setErrorSnackBar({ code: 400, message: 'Failed to fetch webinaires', severity: 'error' });
      setLoading(false);
    }
  };

  const handleAnnulation = async (webinaireId) => {
    const annulationRes = await webinaireServices.deleteRegistrant(webinaireId, userData._id);
    if (annulationRes && annulationRes._id) {
      const webinairesArr = [];
      webinaires.forEach((webinaire) => {
        if (webinaire._id !== webinaireId) {
          webinairesArr.push(webinaire);
        }
      });
      setWebinaires(webinairesArr);
      setSuccessSnackBar({ severity: 'success', message: 'Annulation réussie' });
    } else {
      setErrorSnackBar({ code: 400, message: 'Echec de l\'annulation', severity: 'error' });
    }
  };
  useEffect(() => {
    getWebinairesData();
  }, []);

  return (
    <div
      className={clsx(classes.page, classes.pageWithBg)}
      style={bgStyle}
    >
      {!loading ? (
        <>
          {webinaires.length > 0 ? (
            webinaires.map((webinaire) => (
              <Paper
                key={webinaire._id}
                className={classes.card}
                elevation={2}
              >
                <div className={classes.cardHeaderRow}>
                  <Typography className={classes.meta} component="p" variant="body2">
                    {moment(webinaire.start).format('DD/MM/YYYY [à] HH:mm')}
                  </Typography>
                  <Typography className={classes.meta} component="p" variant="body2">
                    {`Places restantes : ${Math.max(0, webinaire.places - webinaire.registered.length)}`}
                  </Typography>
                </div>
                <Typography className={classes.meta} component="p" variant="body2">
                  {`Durée : ${formatDurationMinutes(webinaire.duration)}`}
                </Typography>
                <Typography component="h2" variant="h6" className={classes.title}>
                  {webinaire.topic}
                </Typography>
                <Typography component="div" variant="body2" align="justify">{parse(webinaire.blurb)}</Typography>
                <div className={classes.actions}>
                  {webinaire.zoomLink ? (
                    <Button
                      component={Link}
                      href={webinaire.zoomLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="contained"
                      color="primary"
                      disableElevation
                      size="small"
                      style={{ textDecoration: 'none' }}
                      aria-label={`Rejoindre le webinaire ${webinaire.topic}`}
                    >
                      Rejoindre
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      disableElevation
                      size="small"
                      disabled
                      aria-label={`Lien du webinaire ${webinaire.topic} indisponible`}
                    >
                      Rejoindre
                    </Button>
                  )}
                  <Button
                    onClick={() => handleAnnulation(webinaire._id)}
                    variant="contained"
                    color="secondary"
                    disableElevation
                    size="small"
                    aria-label={`Annuler l'inscription au webinaire ${webinaire.topic}`}
                  >
                    Annuler
                  </Button>
                </div>
              </Paper>
            ))
          ) : (
            <div className={classes.emptyState}>
              <Typography component="h2" variant="h6" className={classes.emptyTitle}>
                Aucune inscription pour le moment.
              </Typography>
              <Typography variant="body2" className={classes.emptyHint}>
                Réservez une session depuis l&apos;onglet « À venir ».
              </Typography>
            </div>
          )}
        </>
      ) : (
        <Loading />
      )}

    </div>
  );
};

export default RegisteredWebinaire;
